import React from "react";

const Minus = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="4"
      viewBox="0 0 14 4"
      fill="none"
    >
      <rect
        x="14"
        y="0.835938"
        width="2.33333"
        height="14"
        rx="1.16667"
        transform="rotate(90 14 0.835938)"
        fill="#FEC016"
      />
    </svg>
  );
};

export default Minus;
